import * as Yup from "yup";
export class WorkspaceValidation {
}
Object.defineProperty(WorkspaceValidation, "create", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: Yup.object().shape({
        workspaceDescription: Yup.string().required("Workspace Description Is Required."),
        workspaceName: Yup.string().required("Workspace Name Is Required."),
    })
});
